import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dealerService } from "services/dealer.api";
import { setNonApprovedDealerItems } from "store/dealerSlice";
import { selectNonActiveDealers } from "store/dealerSlice";
import { selectDealerItems } from "store/dealerSlice";
import { setDealerItems } from "store/dealerSlice";
import { selectDealer } from "store/dealerSlice";
import { setDealer } from "store/dealerSlice";

const useDealer = () => {
  const dispatch = useDispatch();
  const dealerList = useSelector(selectDealerItems);
  const nonActiveDealers = useSelector(selectNonActiveDealers);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getdealerList = async (payload) => {
    setLoading(true);
    try {
      const response = await dealerService.fetchList(payload);
      if (response.success) {
        dispatch(setDealerItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getdealerOptionList = async () => {
    setLoading(true);
    try {
      const response = await dealerService.fetchOptionList();
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const createdealer = async (payload) => {
    setLoading(true);
    try {
      const response = await dealerService.createDealer(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const updatedealer = async (id, payload) => {
    setLoading(true);
    try {
      const response = await dealerService.updateDealer(id, payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deleteDealer = async (id) => {
    setLoading(true);
    try {
      const response = await dealerService.deleteDealer(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getdealerById = async (id) => {
    setLoading(true);
    try {
      const response = await dealerService.fetchDealerById(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const resendInvitation = async (id) => {
    setLoading(true);
    try {
      const response = await dealerService.resendInvitation(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const nonApprovedDealers = async (payload) => {
    setLoading(true);
    try {
      const response = await dealerService.fetchNonApprovedDealers(payload);
      if (response.success) {
        dispatch(setNonApprovedDealerItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const DealerStatusApprove = async (id) => {
    setLoading(true);
    try {
      const response = await dealerService.dealerStatusApprove(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getdealerList,
    dealerList,
    resendInvitation,
    createdealer,
    getdealerById,
    getdealerOptionList,
    nonApprovedDealers,
    nonActiveDealers,
    DealerStatusApprove,
    deleteDealer,
    updatedealer,
    loading,
    error,
  };
};

export default useDealer;
